module.exports = __webpack_public_path__ + "static/media/TAP-IMAGE.9a81a6f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/TAP-IMAGE.png
// module id = 53
// module chunks = 0